import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: "寻找虹推官 百闻不如一荐",
    },
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import("../views/Detail.vue"),
    meta: {
      title: "奖品兑换及券包领用情况",
    },
  },
  {
    path: '/share',
    name: 'Share',
    component: () => import(/* webpackChunkName: "about" */ '../views/share.vue'),
    meta: {
      title: "专属券包礼赠好友",
    },
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
